import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const CursoRow=({curso, onShowModalBorrar, onShowModalActivar,onShowModalDuplicar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{curso.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">    
                            <List>          
                            <List.Item>
                                    <Link to={"/cursoTest/"+curso.id}> 
                                     <Popup
                                        trigger={<Icon  name='eye' link   size="large"  color="tela" ></Icon>}
                                        content='Visualizar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>          
                            </List>
                        </Table.Cell>              
        </Table.Row>
    
    )
}

//cursoTest


export default CursoRow;